import { useState } from "react";
import { ShoppingBasket, Trash2, Plus, Check } from "lucide-react";
import { toast } from "sonner";
import { useApi, errMsg } from "@/lib/api";

export default function ShoppingTab({ items, reload }) {
  const api = useApi();
  const [name, setName] = useState("");
  const run = async (fn) => { try { await fn(); reload(); } catch (e) { toast.error(errMsg(e)); } };

  const add = (e) => {
    e.preventDefault();
    const v = name.trim();
    if (!v) return;
    setName("");
    run(() => api("post", "/shopping", { items: [{ name: v, category: "Altro" }] }));
  };
  const groups = items.reduce((acc, it) => ({ ...acc, [it.category]: [...(acc[it.category] || []), it] }), {});
  const checkedCount = items.filter((i) => i.checked).length;

  return (
    <div data-testid="shopping-tab" className="max-w-2xl">
      <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight">Lista della spesa</h1>
      <form onSubmit={add} className="mt-6 flex gap-2">
        <input data-testid="shopping-add-input" value={name} onChange={(e) => setName(e.target.value)} placeholder="Aggiungi a mano..."
          className="flex-1 rounded-full border border-[#1C241E]/15 bg-white px-5 py-3 text-sm outline-none focus:border-[#2E6F40]" />
        <button data-testid="shopping-add-button" type="submit" className="rounded-full bg-[#2E6F40] px-4 text-white hover:bg-[#235732]"><Plus className="h-5 w-5" /></button>
      </form>

      {items.length === 0 ? (
        <div className="mt-10 flex flex-col items-center text-center text-[#4F5D52] gap-3 py-16" data-testid="shopping-empty">
          <ShoppingBasket className="h-10 w-10 text-[#D95338]" strokeWidth={1.5} />
          <p>La lista è vuota. Aggiungi gli ingredienti mancanti da una ricetta.</p>
        </div>
      ) : (
        <div className="mt-8 space-y-6">
          {Object.entries(groups).map(([cat, list]) => (
            <section key={cat}>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-[#D95338] mb-2">{cat}</h4>
              <ul className="rounded-3xl border border-[#1C241E]/10 bg-white divide-y divide-[#1C241E]/5">
                {list.map((it) => (
                  <li key={it.id} data-testid="shopping-item" className="flex items-center gap-3 px-4 py-3">
                    <button data-testid={`shopping-check-${it.name}`} onClick={() => run(() => api("patch", `/shopping/${it.id}`, { checked: !it.checked }))}
                      className={`h-6 w-6 shrink-0 rounded-full border-2 flex items-center justify-center transition-colors ${it.checked ? "border-[#2E6F40] bg-[#2E6F40] text-white" : "border-[#1C241E]/25"}`}>
                      {it.checked && <Check className="h-3.5 w-3.5" />}
                    </button>
                    <span className={`flex-1 text-sm ${it.checked ? "line-through text-[#4F5D52]/60" : ""}`}>{it.name}</span>
                    <button data-testid={`shopping-delete-${it.name}`} onClick={() => run(() => api("delete", `/shopping/${it.id}`))} aria-label="Elimina"
                      className="rounded-full p-1.5 text-[#4F5D52] hover:text-[#D95338]"><Trash2 className="h-4 w-4" /></button>
                  </li>
                ))}
              </ul>
            </section>
          ))}
          {checkedCount > 0 && (
            <button data-testid="shopping-clear-checked-button" onClick={() => run(() => api("post", "/shopping/clear-checked"))}
              className="rounded-full border border-[#1C241E]/15 px-5 py-2.5 text-sm font-semibold hover:bg-[#FDF0ED]">
              Rimuovi spuntati ({checkedCount})
            </button>
          )}
        </div>
      )}
    </div>
  );
}
